import React, { useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Item from './Item';
import AddDeal from './AddDeal';
import FetchPipedriveDataButton from './FetchPipedriveDataButton';
import { OverlayTrigger } from 'react-bootstrap';

const Column = ({ dataContext, column, columnId, focusConsultants }) => {
    const {
        store: {
            pipelines,
            currentPipelineId
        }
    } = useContext(dataContext);

    return (
        <div key={columnId} className='d-flex flex-column align-items-center' style={{ flex: 1 }}>
            <div className='w-100'>
                <Droppable droppableId={columnId}>
                    {(provided, snapshot) => {
                        return (
                            <>
                                <div
                                    className={`crm-column-items-container ${snapshot.isDraggingOver ? 'bg-white-smoke-darker' : ''}`}
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}>
                                    <div style={{ height: pipelines[currentPipelineId].viewSettings.topPaddingHeight }} />
                                    <div style={{ height: pipelines[currentPipelineId].viewSettings.bufferHeight }}>
                                        {column.deals &&
                                            column.deals.map((item, index) => {
                                                return <Item key={item.id} item={item} index={index} focusConsultants={focusConsultants} />;
                                            })}
                                        
                                             <div className='add-deal-in-column'>
                                             <AddDeal position='column' pipelineStage={columnId} />
                                         <FetchPipedriveDataButton />
                                    </div>
                                      
                                    </div>
                                    <div style={{ height: pipelines[currentPipelineId].viewSettings.bottomPaddingHeight }} />
                                    {provided.placeholder}
                                    
                                </div>
                            </>
                        );
                    }}
                </Droppable>
            </div>

        </div>
    );
};

export default Column;
